
import CountComponent from '@/components/pages/home/CountComponent.vue';
import {findSpecie, findSpecies} from '@/repositories/local/CountLocal';
import CountItemPayload from '@/models/payloads/CountItemPayload';

export default class CountSpeciesComponent extends CountComponent {
  protected finder = findSpecie;
  protected payload: CountItemPayload[] = findSpecies();
}
